export function getNotFoundMessage(query = '', type: string): string {
  const name = query.trim();
  return name ? `Could not find ${type} "${name}". ` : '';
}
